import ApiClient from './apis/ApiClient';
import apis from './apis';

export default (ctx, inject) => {
    inject('api', apis(ctx));
    inject('client', new ApiClient(ctx));
};
